<template>
    <el-row :gutter="10">
        <v-collapse-wrapper>
            <!-- <div class="acc-top-sec"> -->
            <div class="table-grd grid-stack-item">
                <div class="header">
                    <h1>{{ $t('Search & Reports') }}</h1>
                    <ul class="icon-list">
                        <li><a href="javascript:void(0)" :title="$t('Search')" v-collapse-toggle="'toggle_search'"><i class="icon-advance-search"></i></a></li>
                    </ul>
                </div>
                <v-collapse-wrapper ref="toggle_search">
                    <div class="my-content table-desc" v-collapse-content>
                        <el-row :gutter="10" style="padding: 15px;">
                            <el-col :sm="12" :md="8" :lg="8" :xl="8">
                                <fieldset>
                                    <legend>{{ $t('Search') }}:</legend>
                                    <el-form :model="filterData" ref="filterData" :inline="true">
                                        <div class="bottom-dev">
                                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                                <el-form-item prop="start_date">
                                                    <el-date-picker :picker-options="{disabledDate(date) { return date > new Date() || (filterData.end_date && date > new Date(filterData.end_date));}}" v-model="filterData.start_date" size="small" type="date" :placeholder="$t('Start date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                                <el-form-item prop="end_date">
                                                    <el-date-picker :picker-options="{disabledDate(date) {return date > new Date() || (filterData.start_date && date < new Date(filterData.start_date));}}" v-model="filterData.end_date" size="small" type="date" :placeholder="$t('End date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                                <el-form-item prop="account_number">
                                                    <el-input size="small" v-model="filterData.account_number" :placeholder="$t('Account no')" @keyup.enter.native="handleCurrentChange"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                                <el-form-item prop="receipt_number">
                                                    <el-input size="small" v-model="filterData.receipt_number" :placeholder="$t('Receipt No')" @keyup.enter.native="handleCurrentChange"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                                <el-form-item style="text-align:right; margin-bottom: 10px;">
                                                    <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange" size="small">{{
                                                        $t('Search') }}</el-button>
                                                    <el-button type="cancel" @click="resetForm('filterData')" size="small">{{
                                                        $t('Reset') }}</el-button>
                                                </el-form-item>
                                            </el-col>
                                        </div>
                                    </el-form>
                                </fieldset>
                            </el-col>
                            <el-col :sm="12" :md="8" :lg="10" :xl="8">
                                <fieldset>
                                    <legend>{{ $t('Report') }}:</legend>
                                    <el-form :model="reportFilterData" ref="reportFilterData" :inline="true" :rules="rules">
                                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                            <el-form-item prop="start_date" style="margin-bottom: 20px;">
                                                <el-date-picker :picker-options="{disabledDate(date) { return date > new Date() || (reportFilterData.end_date && date > new Date(reportFilterData.end_date));}}" v-model="reportFilterData.start_date" size="small" type="date" :placeholder="$t('Start date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                            <el-form-item prop="end_date" style="margin-bottom: 20px;">
                                                <el-date-picker :picker-options="{disabledDate(date) {return date > new Date() || (reportFilterData.start_date && date < new Date(reportFilterData.start_date));}}" v-model="reportFilterData.end_date" size="small" type="date" :placeholder="$t('End date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <el-form-item style="text-align:center; margin-bottom: 10px;">
                                                <el-button type="warning" size="mini" @click="generateBookings('daily')">{{ $t('Booking list') }}</el-button>
                                                <el-button type="warning" size="mini" @click="generateReport('daily')">{{ $t('Balance') }}</el-button>
                                                <el-button type="warning" size="mini" @click="generateReport('yearly')">{{ $t('Income Statement') }}</el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-form>
                                </fieldset>
                            </el-col>
                            <el-col :sm="12" :md="8" :lg="6" :xl="8">
                                <fieldset>
                                    <legend>{{ $t('Filter') }}:</legend>
                                    <div class="acc-checkgroup">
                                        <ul>
                                            <li>
                                                <el-checkbox v-model="displayGroup">{{ $t('Group') }}</el-checkbox>
                                            </li>
                                            <li>
                                                <el-checkbox style="margin-left: 0px;" v-model="displayPreviousYear">{{ $t('Previous year') }}</el-checkbox>
                                            </li>
                                            <li>
                                                <el-checkbox style="margin-left: 0px;" v-model="displayZeroAccounts">{{ $t('Zero balance accounts') }}</el-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </fieldset>
                            </el-col>
                        </el-row>
                    </div>
                </v-collapse-wrapper>
            </div>
        </v-collapse-wrapper>
        <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
            <div class="table-grd grid-stack-item">
                <div class="header">
                    <h1>{{ $t('Accounts') }}</h1>
                </div>
                <div class="my-content table-desc">
                    <div :class="{'acc-book':true, 'display-group': !displayGroup}">
                        <ul class="header-ul">
                            <li>{{ $t('Account no') }}</li>
                            <li>{{ $t('Account name') }}</li>
                            <li>{{ $t('Currency') }}</li>
                            <li>{{ $t('Balance') }}</li>
                            <li v-if="displayPreviousYear">{{ $t('Previous year') }}</li>
                        </ul>
                        <v-collapse-group v-for="(cls) in accounts.data" :key="'cls-'+cls.id" :ref="'clsses-'+cls.id" class="acc-book-grp">
                            <v-collapse-wrapper :active="true">
                                <div class="header class-name" v-collapse-toggle @click="changeIcon">
                                    <i class="el-icon-caret-bottom" style="pointer-events: none;"></i>{{ cls.class_number }} {{ cls.name }}
                                </div>
                                <div v-collapse-content>
                                    <v-collapse-group v-for="(grps) in cls.children" :key="'grps-'+grps.id" :ref="'groups-'+grps.id">
                                        <v-collapse-wrapper :active="true">
                                            <div class="header group-name" v-collapse-toggle @click="changeIcon">
                                                <i class="el-icon-caret-bottom" style="pointer-events: none;"></i>{{ grps.group_number }} {{ grps.name }}
                                            </div>
                                            <div class="grp-tbl" v-collapse-content>
                                                <el-table class="acc-table" :data="grps.children" :show-header="false" border :row-class-name="tableRowClassName">
                                                    <el-table-column prop="account_number">
                                                        <template slot-scope="scope">
                                                            <a href="javascript:void(0)" @click="getAccountsBooking(scope.row)">{{ scope.row.account_number }}</a>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="account_name">
                                                    </el-table-column>
                                                    <el-table-column prop="currency_code">
                                                    </el-table-column>
                                                    <el-table-column prop="current_balance" align="right">
                                                        <template slot-scope="scope">
                                                            <span v-cformat="scope.row.current_balance"></span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="last_balance" v-if="displayPreviousYear" align="right">
                                                        <template slot-scope="scope">
                                                            <span v-cformat="scope.row.last_balance"></span>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <span v-if="displayPreviousYear && displayGroup && grps.children.length" class="booktotal" v-cformat="grps.last_amount"></span>
                                                <span v-if="displayGroup && grps.children.length" class="booktotal" :style="'width:'+(displayPreviousYear?'14.5%':'17.5%')" v-cformat="grps.total_amount"></span>
                                            </div>
                                        </v-collapse-wrapper>
                                    </v-collapse-group>
                                    <div style="font-size:12px;">
                                        <span v-if="displayPreviousYear && !displayGroup" class="booktotal" v-cformat="cls.last_amount"></span>
                                        <span v-if="!displayGroup" class="booktotal" v-cformat="cls.total_amount"></span>
                                    </div>
                                </div>
                            </v-collapse-wrapper>
                        </v-collapse-group>
                    </div>
                </div>
            </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">
            <booking-form :rowData="rowData" @popupupdate="updateRow" :dialogFormVisible="dialogFormVisible" @popupsave="reload" @popup="value => { this.dialogFormVisible = value }" />
            <div class="table-grd grid-stack-item">
                <div class="header">
                    <h1>{{ $t('Booking list') }}<span v-if="selectedAcc.account_number">{{ ' '+$t('Of')+' '+selectedAcc.account_number }}</span></h1>
                    <ul class="icon-list">
                        <li v-if="$store.getters.getConfig('has_permissions').includes('account-bookings-store')">
                            <a href="javascript:void(0);" style="color:white" v-if="selectedAcc.account_number" @click="pdfAccountsBooking(selectedAcc.account_number)" :title="$t('pdf download')"><i class="icon-pdf"></i> {{ $t('pdf download') }}</a>
                        </li>
                        <li v-if="$store.getters.getConfig('has_permissions').includes('account-bookings-store')">
                            <a href="javascript:void(0);" style="color:white" v-if="selectedAcc.account_number" @click="exportExcel(selectedAcc.account_number)" :title="$t('export excel')"><i class="icon-excel"></i> {{ $t('export excel') }}</a>
                        </li>
                        
                    </ul>
                    <ul class="icon-list">
                        <li v-if="$store.getters.getConfig('has_permissions').includes('account-bookings-store')">
                            <a href="javascript:void(0);" @click="handleCreate()" :title="$t('Create')"><i class="icon-add"></i></a>
                        </li>
                    </ul>

                </div>
                <div class="my-content table-desc">
                    <div class="acc-book">
                        <el-table class="booking-list acc-table" @sort-change="handleSortChange" :data="bookings.data" :row-class-name="highlightDisable">
                            <el-table-column label="#" width="40" v-if="$store.getters.getConfig('has_permissions').includes('account-bookings-destroy')">
                                <template slot-scope="scope">
                                    <a v-if="scope.row.locked_booking_id == null" href="javascript:void(0);" @click="handleDelete(scope.$index, scope.row)"><i class=" icon-delete"></i></a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="related_account_number" :label="$t('To account')" width="100">
                                <template slot-scope="scope">
                                    <a href="javascript:void(0)" @click="handleEdit(scope.row)">{{ scope.row.related_account_number }}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="receipt_number" :label="$t('Receipt No')" width="100">
                            </el-table-column>
                            <el-table-column prop="booking_date" sortable="custom" :label="$t('Date')" width="100">
                                <template slot-scope="scope">
                                    <span v-date-format="scope.row.booking_date"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="booking_text" :label="$t('Description')" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="debited_amount" :label="$t('Debit')" align="right" width="90">
                                <template slot-scope="scope">
                                    <span v-cformat="scope.row.debited_amount"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="credited_amount" :label="$t('Credit')" align="right" width="90">
                                <template slot-scope="scope">
                                    <span v-cformat="scope.row.credited_amount"></span>
                                </template>
                            </el-table-column>

                            <!-- <el-table-column prop="credited_amount" :label="$t('Debit')" align="right" width="90">
                                <template slot-scope="scope">
                                    <span v-cformat="scope.row.credited_amount"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="debited_amount" :label="$t('Credit')" align="right" width="90">
                                <template slot-scope="scope">
                                    <span v-cformat="scope.row.debited_amount"></span>
                                </template>
                            </el-table-column> -->

                            <el-table-column prop="resulted_amount" :label="$t('Balance')" width="100" align="right">
                                <template slot-scope="scope">
                                    <span v-cformat="scope.row.resulted_amount"></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<style lang="scss">
    .el-table .disabled-row {
        background-color: var(--table-row-hover-color);
    }

    .el-table .hide-row {
        display: none;
    }

    .acc-checkgroup .el-checkbox__label {
        font-size: 11px;
    }

    .booking-list th {
        text-transform: capitalize;
    }

    .acc-table {
        font-size: 14px;
    }

    .acc-top-sec {
        display: flex;
        width: calc(100% - 10px);
        background: #fff;
        margin: 0 0 20px 5px;
        padding: 10px 10px 18px 10px;
        border-radius: 4px;
    }

    .acc-top-sec .el-input__prefix {
        left: unset;
        right: 5px;
    }

    .acc-top-sec .el-date-editor {
        width: 100%;
    }

    .acc-top-sec .el-input--prefix .el-input__inner {
        padding-left: 15px;
    }

    .acc-checkgroup li {
        list-style: none;
    }

    .acc-checkgroup li .el-checkbox__label {
        text-transform: capitalize;
    }

    fieldset {
        display: block;
        margin-left: 2px;
        margin-right: 2px;
        padding-top: 1em;
        padding-bottom: 0;
        padding-left: 0.75em;
        padding-right: 0.75em;
        border: 1px solid var(--base-theme-color);
        height: 100%;

        legend {
            padding: 0 10px;
        }
    }

    @media only screen and (max-width: 375px) {
        .acc-book {
            .header-ul {
                display: flex;

                li {
                    word-break: break-word;
                    display: inline-flex;
                    width: auto !important;
                    line-height: normal;
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .acc-top-sec {
            display: inline-block;
        }
    }

</style>

<script>
    import BookingForm from './Form'
    import VueExcelXlsx from 'xlsx/xlsx';
    export default {
        components: {
            BookingForm
        },
        data() {
            return {
                formData : {},
                filterData: {
                    sortBy: 'booking_date',
                    order: 'asc',
                    account_id: 0
                },
                reportFilterData: {
                    start_date: null,
                    end_date: null
                },
                dialogFormVisible: false,
                rowData: {},
                accounts: {},
                selectedAcc: {},
                bookings: {},
                displayGroup: true,
                displayPreviousYear: true,
                displayZeroAccounts: false,
                last_account_booking_id: 0,
                startDateRequired: false,
                endDateRequired: false,
                columns : [
                    {
                        label: this.$t('To account'),
                        field: 'related_account_number',
                    },
                    {
                        label: this.$t('Receipt No'),
                        field: 'receipt_number',
                    },
                    {
                        label: this.$t('Date'),
                        field: 'booking_date',
                        dataFormat: this.dateFormat
                    },
                    {
                        label: this.$t('Title'),
                        field: 'booking_text',
                    },
                    {
                        label: this.$t('Debit'),
                        field: 'debited_amount',
                    },
                    {
                        label: this.$t('Credit'),
                        field: 'credited_amount',
                        trigger: ['blur'],
                    },
                    {
                        label: this.$t('saldo'),
                        field : 'resulted_amount',
                    },
                ]
            };
        },
        computed: {
            rules() {
                return { 
                    start_date: [{ 
                        required: this.startDateRequired, 
                        message: this.$t('This field is required'),
                    }],
                    end_date: [{ 
                        required: this.endDateRequired, 
                        message: this.$t('This field is required'),
                    }]
                }
            }
        },
        mounted() {
            this.getSettings();
            this.getAccounts();            
        },
        methods: {
            getSettings() {
                request({
                    url: "account-settings",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.reportFilterData.start_date = response.data.data.start_date;
                    this.reportFilterData.end_date = response.data.data.end_date;
                });
            },
            tableRowClassName({
                row
            }) {
                if (row.current_balance == 0 && row.last_balance == 0 && !this.displayZeroAccounts) {
                    return 'hide-row';
                }
                return '';
            },
            highlightDisable({
                row,
                rowIndex
            }) {
                if (row.locked_booking_id != null) {
                    return 'disabled-row';
                }
                return '';
            },
            reload() {
                this.getAccounts();
                // this.getAccountsBooking()
            },
            getAccounts() {
                if ((this.filterData.start_date && !this.filterData.end_date) || (!this.filterData.start_date && this.filterData.end_date))
                    return false;
                request({
                    url: "get-account-group-class",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.accounts = response.data;
                    this.getAccountsBooking(this.accounts.last_credit_account);
                });
            },
            getAccountsBooking(acc = null) {
                if(acc != null){
                    this.selectedAcc = acc;
                    this.filterData.account_id = acc.id;
                }
                if(this.filterData.receipt_number && this.filterData.account_id){
                    this.selectedAcc = {};
                    delete this.filterData.account_id;
                }
                
                // if ((!this.filterData.receipt_number && !this.filterData.account_id) || (!this.selectedAcc && !this.filterData.receipt_number) || (this.filterData.start_date && !this.filterData.end_date) || (!this.filterData.start_date && this.filterData.end_date))
                //     return false;
                request({
                    url: "account-bookings",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.bookings = response.data;
                });
            },
            handleCreate() {
                this.rowData = {
                    currency_rate: '1.00',
                    currency_code: this.$store.state.config.generalSettings.currency_code,
                    document_date: null,
                    credited_account_id: null,
                    debited_account_id: null,
                    booking_amount: 0
                };
                this.dialogFormVisible = true;
            },
            handleEdit(row) {
                this.rowData = row;
                this.rowData.edit = true;
                this.dialogFormVisible = true;
            },
            updateRow(row) {
                this.getAccounts();
                this.getAccountsBooking()
            },
            changeIcon(event) {
                event.target.children[0].classList.toggle('rotate');
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.reload();
            },
            handleCurrentChange(event, a) {
                if (event && event.type == "blur") {
                    if (event.target.value)
                        this.reload();
                } else {
                    this.reload();
                }
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "booking_date";
                    this.filterData.order = "asc";
                }
                this.getAccountsBooking();
            },
            handleDelete(index, row) {
                this.$confirm(
                    this.$t('This will permanently delete the') + ' ' + this.$t('Booking') + '. ' + this.$t(
                        'Do you want to continue?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('OK'),
                        cancelButtonText: this.$t('Cancel'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "account-bookings/" + row.id,
                            method: "delete",
                            data: {}
                        })
                        .then(response => {
                            this.getAccounts();
                            this.getAccountsBooking();
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                });
            },
            generateReport(type) {
                if (type == 'yearly') {
                    this.startDateRequired = true
                    this.endDateRequired = true
                    if(typeof this.reportFilterData.start_date !== 'undefined' && typeof this.reportFilterData.end_date !== 'undefined') {
                        this.reportFilterData.report_type = 'yearly'
                        // this.$router.push({ name: 'IncomeStatement', params: { filterData: this.reportFilterData }});
                        let routeData = this.$router.resolve({name: 'IncomeStatement', query: {'start_date': this.reportFilterData.start_date,'end_date':this.reportFilterData.end_date,'report_type':'yearly'}});
                        window.open(routeData.href, '_blank');
                    }
                    
                } else if(type == 'daily') {
                    this.startDateRequired = false
                    this.endDateRequired = true
                    if(typeof this.reportFilterData.end_date !== 'undefined') {
                        this.reportFilterData.report_type = 'daily'
                        this.reportFilterData.start_date = this.reportFilterData.start_date
                        // delete this.reportFilterData.end_date
                        // this.$router.push({ name: 'DailyBalanceSheet', params: { filterData: this.reportFilterData }});
                        let routeData = this.$router.resolve({name: 'DailyBalanceSheet', query: {'start_date': this.reportFilterData.start_date,'report_type':'daily'}});
                        window.open(routeData.href, '_blank');
                    }
                }
            },
            generateBookings() {
                    this.startDateRequired = true
                    this.endDateRequired = true
                    if(typeof this.reportFilterData.start_date !== 'undefined' && typeof this.reportFilterData.end_date !== 'undefined') {
                        let routeData = this.$router.resolve({name: 'BookingLits', query: {'start_date': this.reportFilterData.start_date,'end_date':this.reportFilterData.end_date}});
                        window.open(routeData.href, '_blank');
                    }
            },
            pdfAccountsBooking(account_number = null) {
                 if (account_number !== 'undefined') {
                    let routeData = this.$router.resolve({name: 'BookingsStatement', query: {'sortBy':'booking_date','order':'asc','account_number':account_number,'start_date': this.filterData.start_date,'end_date':this.filterData.end_date,'receipt_number':this.filterData.receipt_number}});
                    window.open(routeData.href, '_blank');                    
                }
            },
            exportExcel(account_number = null) {
                let createXLSLFormatObj = [];
                let creditAmount = [];
                let debitAmount = [];
                let balance = [];
                let newXlsHeader = [];
                let vm = this;
                if (vm.columns.length === 0) {
                    return;
                }
                if (vm.bookings.data.length === 0) {
                    return;
                }
                $.each(vm.columns, function(index, value) {
                    newXlsHeader.push(value.label);
                });
                createXLSLFormatObj.push(newXlsHeader);
                $.each(vm.bookings.data, function(index, value) {
                    let innerRowData = [];
                    debitAmount.push(value['debited_amount']);
                    creditAmount.push(value['credited_amount']);
                    $.each(vm.columns, function(index, val) {
                        if (val.dataFormat && typeof val.dataFormat === 'function') {
                            innerRowData.push(val.dataFormat(value[val.field]));
                        }else {
                            innerRowData.push(value[val.field]);
                        }
                    });
                    balance = value['resulted_amount'];
                    console.log(innerRowData);
                    createXLSLFormatObj.push(innerRowData);
                });
                var totalDebit = 0;
                var totalCredit = 0;
                $.each(debitAmount, function (index, value) {
                    totalDebit += Number(value);
                });
                $.each(creditAmount, function (index, value) {
                    totalCredit += Number(value);
                });
                createXLSLFormatObj.push(['', '', '', '', '', '', '']);
                createXLSLFormatObj.push(['', '', '', '', totalCredit.toFixed(2), totalDebit.toFixed(2), balance]);
                console.log(createXLSLFormatObj);
                let filename = 'booking-list-'+ account_number + ".xlsx";
                let ws_name = 'booking-list';
                let wb = VueExcelXlsx.utils.book_new(),
                    ws = VueExcelXlsx.utils.aoa_to_sheet(createXLSLFormatObj);
                VueExcelXlsx.utils.book_append_sheet(wb, ws, ws_name);
                VueExcelXlsx.writeFile(wb, filename);
            },
            priceFormat(value){
                return value;
            },
            dateFormat(value){
                return value.split('-').reverse().join('-')
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Layout/AccountBookings/AccountBookings.vue